import { useState, useEffect } from 'react'

import Api from 'services/api'
import { ConsumerRTHData } from '@nexiahome/ui-common/themes/util/types'

type Props = {
  deviceId: string
}

const useConsumerRth = ({ deviceId }: Props) => {
  const [dailyData, setDailyData] = useState<ConsumerRTHData>()
  const [monthlyData, setMonthlyData] = useState<ConsumerRTHData>()
  const [isDailyDataLoaded, setIsDailyDataLoaded] = useState(false)
  const [isMonthlyDataLoaded, setIsMonthlyDataLoaded] = useState(false)

  useEffect(() => {
    setIsDailyDataLoaded(false)
    setIsMonthlyDataLoaded(false)

    Api.ConsumerRth.getDaily(deviceId)
      .then((res) => {
        setDailyData(res)
        setIsDailyDataLoaded(true)
      })
      .catch(() => {
        setIsDailyDataLoaded(true)
      })
    Api.ConsumerRth.getMonthly(deviceId)
      .then((res) => {
        setMonthlyData(res)
        setIsMonthlyDataLoaded(true)
      })
      .catch(() => {
        setIsMonthlyDataLoaded(true)
      })
  }, [deviceId])

  return { dailyData, isDailyDataLoaded, monthlyData, isMonthlyDataLoaded }
}

export default useConsumerRth
